<template>
  <header id="page-header" class="flex justify-between gap-6 max-[768px]:gap-12 max-h-[50rem] text-[#334155]">
    <div id="header-info-container" class="flex flex-col justify-between gap-8">
      <div class="flex flex-col">
        <div id="header-breadcrumbs" class="flex gap-2 items-center mb-10">
          <span class="not-clickable">Article</span>
          <span class="separator">></span>
          <a 
            :href="`${allArticlesPath}?category=${this.categoryKey}`"
            :disabled="!this.categoryKey"
            :class="[
              { 'clickable': this.categoryKey }
            ]"
          >{{ pageCategory }}</a>
        </div>
        <h1 class="text-[2.5rem] leading-[3rem] mb-12 max-[768px]:mb-8">{{ title }}</h1>
        <div class="flex flex-col text-[0.875rem]">
          <span class="leading-[1.25rem]">By {{ authorName || 'unknown author' }}</span>
          <span class="leading-[1.6875rem]">{{ parsedCreatedAt }} • {{ readTime.toFixed(0) }} min read</span>
        </div>
      </div>
      <ShareLinks :page-path="articlePath" />
    </div>
    <div id="header-img-container" class="flex rounded-lg">
      <img 
        :src="imageUrl || imagePlaceholder || '../../../images/placeholder.webp'"
        alt="Article header image"
        class="aspect-auto object-cover"
      />
    </div>
  </header>
</template>
<script>
import ShareLinks from '../article-share-links/index.vue'

export default {
  components: {
    ShareLinks
  },
  props: {
    imagePlaceholder: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    teaser: {
      type: String,
      default: ''
    },
    articlePath: {
      type: String,
      required: true
    },
    categoryKey: {
      type: String,
      required: true
    },
    authorName: {
      type: String,
      default: 'unknown author'
    },
    createdAt: {
      type: String,
      default: ''
    },
    readTime: {
      type: Number,
      default: 5
    },
    imageUrl: {
      type: String,
      default: ''
    },
    allArticlesPath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pageCategoriesMapping: [
        {
          key: 'how_to_guide',
          value: 'How To Guide'
        },
        {
          key: 'shipping_containers',
          value: 'Shipping Containers'
        },
        {
          key: 'office_containers',
          value: 'Office Containers'
        }
      ]
    }
  },
  computed: {
    pageCategory() {
      return this.pageCategoriesMapping.find(category => category.key === this.categoryKey)?.value || 'How To Guide'
    },

    parsedCreatedAt() {
      if (!this.createdAt) return ''
      
      return this.$luxon(this.createdAt, 'dd MMM yyyy')
    }
  }
}
</script>

<style lang="scss" scoped>
#page-header {
  margin: 7rem auto;
  max-width: 1440px;
  font-weight: 400;

  #header-info-container {
    flex: 1 1 auto;
  
    #header-breadcrumbs {
      font-size: 1rem;
      line-height: 1.5rem;
    
      .separator {
        font-size: 0.75rem;
        line-height: 1rem;
        width: 1rem;
        vertical-align: middle;
        text-align: center;
      }

      .clickable {
        color: #0077FF;
        text-decoration: none;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  
  #header-img-container {
    overflow: hidden;
  
    img {
      aspect-ratio: 4 / 3;
      object-fit: cover;
      max-height: 28.125rem;
      width: auto;
    }
  }
}

@media (max-width: 1024px) {
  #page-header {
    margin: 4rem 1rem;
  }
}

@media (max-width: 768px) {
  #page-header {
    flex-wrap: wrap;
    margin: 4rem 1rem;
  }
}
</style>
